import React from 'react';

import { getImgixSrc } from '@utils/images';

import MobileStepWithMedia from '../MobileStepWithMedia';

interface NewslettersProps {
  handleClose: () => void;
  handleNext: () => void;
  isProSubscriber: boolean;
  step: number;
  totalSteps?: number;
}

const NEWSLETTERS_IMAGE_SRC = getImgixSrc({
  path: 'tooltip/newsletters.png',
  isEnvDependent: false,
});

const Newsletters = ({
  handleClose,
  handleNext,
  isProSubscriber,
  step,
  totalSteps = 5,
}: NewslettersProps) => (
  <MobileStepWithMedia
    description="6+ informative newsletters"
    handleClose={handleClose}
    handleNext={handleNext}
    isProSubscriber={isProSubscriber}
    media={
      <img
        src={NEWSLETTERS_IMAGE_SRC}
        alt="Newsletters"
        className="h-full w-full object-cover object-top"
      />
    }
    showCloseButton={true}
    step={step}
    title="Newsletters"
    totalSteps={totalSteps}
  />
);

export default Newsletters;
